import { STATUS_DESCRIPTION_MAP } from 'constants/tracking-v2/invoice-indicators';
import { multiSelectorOptionsMapper, optionsMapper } from '../utils';

const options = Object
  .entries(STATUS_DESCRIPTION_MAP)
  .map(([key, value]) => ({ label: value, value: key }));

export const useInvoiceIndicatorStatusOptions = () => {
  return {
    singleSelectOptions: options.map(optionsMapper),
    multiSelectOptions: options.map(multiSelectorOptionsMapper),
  }
}